var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniproject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u8303/\\u5207\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8861\\u6CF0\\u4FE1\\u4F1A\\u6240\\u89C4\\u83032",
    transform: "translate(-220.000000, -1384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(110.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(0.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "precise.monitor",
    transform: "translate(110.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "precise.monitor-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L20,20 L0,20 L0,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0.0000999999975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,6.25 L10.625,6.25 L10.625,1.875 L9.375,1.875 L9.375,6.25 Z M3.37087393,2.48699045 L2.48699045,3.37087393 L6.90640783,7.79029131 L7.79029131,6.90640783 L3.37087393,2.48699045 Z M16.6291265,2.48699051 L17.51301,3.37087393 L13.0935926,7.79029131 L12.2097092,6.90640783 L16.6291265,2.48699051 Z M10,11.25 C9.53732347,11.25 9.13335848,10.9986258 8.91722775,10.625 L1.875,10.625 L1.875,9.375 L8.91722775,9.375 C9.13335848,9.00137424 9.53732347,8.75 10,8.75 C10.6903563,8.75 11.25,9.30964422 11.25,10 C11.25,10.6903563 10.6903563,11.25 10,11.25 Z M2.48699045,16.6291265 L3.37087393,17.51301 L7.79029131,13.0935926 L6.90640783,12.2097092 L2.48699045,16.6291265 Z M17.51301,16.6291265 L16.6291265,17.51301 L12.2097092,13.0935926 L13.0935926,12.2097092 L17.51301,16.6291265 Z M13.75,9.375 L13.75,10.625 L18.125,10.625 L18.125,9.375 L13.75,9.375 Z M9.375,13.75 L10.625,13.75 L10.625,18.125 L9.375,18.125 L9.375,13.75 Z",
    id: "precise-monitor",
    fillOpacity: 0.9,
    fill: "currentColor"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniproject);
export default __webpack_public_path__ + "static/media/miniproject.da288634f69d68687dcc7b688d70e1d9.svg";
export { ForwardRef as ReactComponent };